import axios from 'axios'
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,
} from '../constants/userConstants'

import {
    VIDEO_LIST_REQUEST,
    VIDEO_LIST_SUCCESS,
    VIDEO_LIST_FAIL,
    VIDEO_LIST_RESET,
} from '../constants/videoConstants'

import{
    PROXY_SERVER,
} from '../constants/proxyConstants'



// 要參考useraction 裡面的getUserDetails 怎麼判別
// 用async 的原因是因為 如果今天除了listVideos的func以外 
// 不用等listVideos處理完 就可以直接異步了
export const listVideos_action =(id) => async (dispatch,getState) =>{

    try{
        //----先執行 request dispatch把東西送到reducer裡面
        // case VIDEO_LIST_REQUEST:
        //     return {loading:true, videos:[]}
        dispatch({
            type:VIDEO_LIST_REQUEST
        })

        // userInfo localstorage裡面的token
        const {
            userLogin: {userInfo},
        } = getState()

        const config = {
            headers:{
                'Content-type': 'application/json',
                Authorization : `Bearer ${userInfo.token}`
            }
        }

        const {data} = await axios.get(
            `${PROXY_SERVER}/api/videos/${id}/`,
            config
        )


        // case VIDEO_LIST_SUCCESS:
        //     return {loading:false,videos:action.payload}
        dispatch({
            type:VIDEO_LIST_SUCCESS,
            payload:data
        })

    }catch(error){
        // 發生fail 直接執行logout 程序
        localStorage.removeItem('userInfo')
        dispatch({ type:USER_LOGOUT })
        dispatch({ type:USER_DETAILS_RESET })
        dispatch({ type:VIDEO_LIST_RESET })
        /*
        dispatch({
            type:VIDEO_LIST_FAIL,
            payload:error.response && error.response.data.detail
                ? error.response.data.detail
                :error.message,
        })
        */
    }
}
